export const NAME = 'applicationTracking';
